module.exports = __webpack_public_path__ + "c384d7912d35f915e2dd7f8abeaf420f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp9.jpeg
// module id = 1143
// module chunks = 0